import { User, Mail, Calendar } from 'lucide-react'
import { formatDate } from './utils'

interface ClientInfoCardProps {
  clientName: string
  clientEmail: string
  createdAt: string
}

export function ClientInfoCard({ clientName, clientEmail, createdAt }: ClientInfoCardProps) {
  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5">
      <h2 className="text-lg font-semibold text-slate-900 mb-4 flex items-center gap-2">
        <User className="h-5 w-5 text-slate-400" />
        Mandant
      </h2>
      <div className="space-y-3">
        <div className="flex items-center gap-2 text-slate-700">
          <User className="h-4 w-4 text-slate-400" />
          <span>{clientName}</span>
        </div>
        <div className="flex items-center gap-2 text-slate-700">
          <Mail className="h-4 w-4 text-slate-400" />
          <a href={`mailto:${clientEmail}`} className="text-blue-600 hover:underline">
            {clientEmail}
          </a>
        </div>
        <div className="flex items-center gap-2 text-slate-500 text-sm">
          <Calendar className="h-4 w-4 text-slate-400" />
          Erstellt am {formatDate(createdAt)}
        </div>
      </div>
    </div>
  )
}
